import OTP from 'otp'

/**
 * Generates a new base32 TOTP secret used when setting up 2FA.
 *
 * The trailing `=` padding is stripped because some authenticator apps reject it.
 * See https://github.com/pipobscure/otp/issues/16
 */
export const generateOTPSecret = () => new OTP().secret.replaceAll('=', '')
